
export const SOCIAL_MEDIA_OPTIONS = ['Twitter', 'Telegram', 'Youtube', 'Other'];

export const PAYMENT_STRUCTURE_OPTIONS = ['Milestone Based', 'Annually', 'One-time payment', 'Monthly', 'Other'];

export const REGION_OPTIONS = ['IN', 'TR', 'CN', 'JP', 'KR', 'ID', 'ES', 'VN', 'RU', 'EN'];

export const TIER_OPTIONS = ['Tier 0', 'Tier 1', 'Tier 2', 'Tier 3'];

export const CURRENCY_OPTIONS = [
  'USD', 'EUR', 'JPY', 'GBP', 'AUD', 'CAD', 'CHF', 'CNY', 'HKD', 'NZD', 
  'USDT', 'USDC', 'MNT', 'BTC', 'ETH', 'COOK'
];

export const CONTENT_TYPE_OPTIONS = [
  'Twitter - QT', 'Twitter - Tweet', 'Twitter - RT', 'Twitter - Thread/long post',
  'Telegram - post', 'Youtube - full video', 'Youtube - integration', 
  'Naver - Blog', 'Blogs or News', 'PR', 'AMA', 'Others'
];

export const INTERNAL_KOL_TYPE_OPTIONS = ['Type 1 - CVR', 'Type 3 - media/PR', 'Type 2 - mindshare'];
